import { FeedbackCategory } from "../Constants/feedbackEnums";

interface IFeedbackCategoryService {
  getDisplayNameForCategory: (category: FeedbackCategory) => string;
}

class FeedbackCategoryService implements IFeedbackCategoryService {
  getDisplayNameForCategory(category: FeedbackCategory): string {
    switch (category) {
      case FeedbackCategory.FeatureRequest:
        return "Feature Request";
      case FeedbackCategory.BugReport:
        return "Bug Report";
      case FeedbackCategory.ResourceRequest:
        return "Resource Request";
      default:
        throw new Error(`Invalid feedback category "${category}"`);
    }
  }
}

export const feedbackCategoryService = new FeedbackCategoryService();
